/* eslint-disable no-console */
const dev = process.env.NODE_ENV !== "production";

export const logDebug = (...args) => {
    if (dev) console.log(...args);
};

export const logWarn = (...args) => {
    if (dev) console.warn(...args);
};

export const logError = (...args) => {
    if (dev) console.error(...args);
};
